import { createApp } from 'vue'
import App from './App.vue'
// import VueAxios from 'vue-axios'
import ApiService from "./common/api.service";
import ApiIntegrasiService from "./common/api.integrasi.service";
import ApiHIService from "./common/api.hi.service";
import axios from 'axios';
import './registerServiceWorker'
import router from './router';
import 'bootstrap/dist/css/bootstrap.css'
import './assets/css/style.css';
import './assets/css/custom.css';
import store from './store/index'
import { db } from './firebase'
import { doc, setDoc } from 'firebase/firestore'
import { getProfileUser, logout } from '@/authService'

window.moment = require('moment');
moment.locale('ms-my'); 
export const app = createApp(App);
app.config.ignoredElements  = tag => tag.startsWith('ion-');

// Attach axios instances directly to the app to avoid plugin/circular issues
app.axios = axios
app.axiosMasmed = ApiService.init()
app.axiosIntegrasi = ApiIntegrasiService.init()
app.axiosApiHIService = ApiHIService.init()

// Also provide them on globalProperties for components
app.config.globalProperties.$axios = axios
app.config.globalProperties.$axiosMasmed = app.axiosMasmed
app.config.globalProperties.$axiosIntegrasi = app.axiosIntegrasi
app.config.globalProperties.$axiosApiHIService = app.axiosApiHIService

app.use(router);
app.use(store);

// Mount the app
app.mount('#app');

// On app start: honour an admin-initiated one-time force logout.
//
// NOTE: We intentionally do NOT log the student out when the medical-form
// `token_mystudent` token is missing/expired. That token is only required to
// upload borang C, and MedicalForm.vue already gates the upload (and shows a
// "log masuk semula" modal) on its own. Gating *app-wide* login on it caused a
// login loop for every student whose Cloud Function token was never minted or
// had expired (they could never get past /login).
(async () => {
	try {
		const profile = await getProfileUser()
		if (!profile || !profile.studentid) return

		if (profile.force_logout) {
			// Reset the flag first so this is a single kick, not a permanent loop
			// (nothing else ever sets it back to false).
			try {
				await setDoc(
					doc(db, `pelajar/${profile.studentid}@student.uitm.edu.my`),
					{ force_logout: false },
					{ merge: true }
				)
			} catch (e) {
				console.warn('Failed to reset force_logout flag:', e)
			}

			try {
				await logout()
			} catch (e) {
				console.warn('Sign-out failed:', e)
			}

			// Clear local storage items used by the app (match LogoutPage.vue cleanup)
			localStorage.removeItem('access_token')
			localStorage.removeItem('refresh_token')
			localStorage.removeItem('id_token')
			localStorage.removeItem('user_info')
			localStorage.removeItem('mystudent-from')
			localStorage.removeItem('user')
			localStorage.removeItem('token')

			// Redirect to login so next open requires authentication
			window.location.href = '/login'
		}
	} catch (err) {
		console.error('Forced logout startup check error:', err)
	}
})()

import 'bootstrap/dist/js/bootstrap.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';